import React from 'react'
import { NavLink, useHistory } from 'react-router-dom'
import { FormattedMessage } from 'react-intl'
import { NamedRoutes } from '../../../../routes'
import { formatRoute } from 'react-router-named-routes'
import {
  Box, Button, ButtonGroup, ClickAwayListener,
  Container, Grow, MenuItem, MenuList, Paper, Popper
} from '@material-ui/core'
import Alert from '@material-ui/lab/Alert'
import { CompanyConsumer } from '../../../../CompanyContext'
import { SearchLoader } from '../../../Loader/SearchLoader'
import { FormLoader } from '../../../Loader/FormLoader'
import { isEmpty } from '../../../../utils/helpers'
import EmptyResult from '../../../EmptyResult'
import UnAuthorize from '../../../UnAuthorize'
import PaymentsBalanceFilter from './PaymentsBalanceFilter'
import { useStyles } from './Styles'
import PaymentsBalanceTable from './PaymentsBalanceTable/Table'
import { sm } from '../../../../utils/ResponsiveUtility'
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown'
import Configuration from '../../../../Services/Api/Configuration'

const CompanyPaymentsBalance = ({
                                  selectedCompany,
                                  handleSubmitBalancePaymentsFilter,
                                  paymentsFiltersData,
                                  availableBalance,
                                  paymentsFiltersFailure,
                                  setBreadCrumbLinks,
                                  setBreadCrumbCurrent
                                }) => {
  const classes = useStyles()
  let history = useHistory()
  const btnOptions = [
    {
      text: <FormattedMessage id='PaymentsContent.ActionLinks.PaymentRequests'/>,
      action: () => history.push({
        pathname: formatRoute(NamedRoutes.workspace.company.paymentRequests, { id: selectedCompany.id })
      })
    },
    {
      text: <FormattedMessage id='PaymentsContent.ActionLinks.PaymentReceipts'/>,
      action: () => history.push({
        pathname: formatRoute(NamedRoutes.workspace.company.paymentReceipts, { id: selectedCompany.id })
      })
    }
  ]
  if (!Configuration?.HIDE_PAYMENT_CLAIMS_MENUITEM) {
    btnOptions.push(
      {
        text: <FormattedMessage id='workspaceMenu.link.item65'/>,
        action: () => history.push({
          pathname: formatRoute(NamedRoutes.workspace.company.paymentClaims, { id: selectedCompany.id })
        })
      }
    )
  }


  React.useEffect(() => {
      if (!!Object.keys(paymentsFiltersData).length && paymentsFiltersData?.payment_tax_types?.length) {
        if (!!handleSubmitBalancePaymentsFilter) {
          handleSubmitBalancePaymentsFilter({
            ClaimtStatus: '5',
            TaxPaymentType: paymentsFiltersData?.payment_tax_types[0]?.code || ''
          }, null)
          // handleSubmitBalancePaymentsFilter({ TaxType: paymentsFiltersData?.payment_tax_types[0]?.code || '' }, null)
        }
      }
    },// eslint-disable-next-line react-hooks/exhaustive-deps
    [paymentsFiltersData])

  React.useEffect(() => {
      if (!!setBreadCrumbLinks && !!selectedCompany && !isEmpty(selectedCompany)) {
        setBreadCrumbLinks((prevLinks) => [...prevLinks,
          {
            key: 'BreadcrumbLink-2',
            name: selectedCompany.taxpayer_name,
            link: formatRoute(NamedRoutes.workspace.company.view, { id: selectedCompany.id })
          },
          {
            key: 'BreadcrumbLink-3',
            name: <FormattedMessage id='workspaceMenu.link.item64'/>,
            link: formatRoute(NamedRoutes.workspace.company.payments, { id: selectedCompany.id })
          }])
        setBreadCrumbCurrent(<FormattedMessage id='workspaceMenu.link.PaymentsBalance'/>)
      }
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [])

  const [open, setOpen] = React.useState(false)
  const anchorRef = React.useRef(null)

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen)
  }

  const handleClose = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return
    }

    setOpen(false)
  }

  const [width, setWidth] = React.useState(document.body.clientWidth)

  let Mobile = (width < sm)
  React.useEffect(() => {
    const getWidth = () => {
      setWidth(document.body.clientWidth)
    }
    window.addEventListener('resize', getWidth)
    return () => {
      window.removeEventListener('resize', getWidth)
    }
  }, [width])

  return (
    <>
      {!!selectedCompany && !isEmpty(selectedCompany) &&
      <Container disableGutters maxWidth="lg" className={classes.paymentsActionLinksContainer}>
        {!!Mobile ?
          <>
            <ButtonGroup variant="contained" color="primary" ref={anchorRef} aria-label="split button">
              <Button onClick={btnOptions[0].action}>{btnOptions[0].text}</Button>
              <Button
                color="primary"
                size="small"
                aria-controls={open ? 'split-button-menu' : undefined}
                aria-expanded={open ? 'true' : undefined}
                aria-label="select merge strategy"
                aria-haspopup="menu"
                onClick={handleToggle}
              >
                <ArrowDropDownIcon/>
              </Button>
            </ButtonGroup>
            <Popper open={open} className={classes.btnPopper} anchorEl={anchorRef.current} role={undefined} transition
                    disablePortal>
              {({ TransitionProps, placement }) => (
                <Grow
                  {...TransitionProps}
                  style={{
                    transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom'
                  }}
                >
                  <Paper>
                    <ClickAwayListener onClickAway={handleClose}>
                      <MenuList id="split-button-menu">
                        {btnOptions.map((btnObj, index) => (
                          <MenuItem
                            key={index}
                            selected={index === 0}
                            onClick={btnOptions[index].action}
                          >
                            {btnObj.text}
                          </MenuItem>
                        ))}
                      </MenuList>
                    </ClickAwayListener>
                  </Paper>
                </Grow>
              )}
            </Popper>
          </> :
          <>
            <ButtonGroup size="large" variant={'contained'} color="primary"
                         aria-label="large outlined primary button group">
              <Button onClick={btnOptions[0].action}>
                {btnOptions[0].text}
              </Button>
              <Button onClick={btnOptions[1].action}>
                {btnOptions[1].text}
              </Button>
            </ButtonGroup>
            {!!btnOptions[2] &&
            <ButtonGroup size="large" variant={'contained'} color="primary"
                         aria-label="large outlined primary button group">
              <Button onClick={btnOptions[2].action}>
                {btnOptions[2].text}
              </Button>
            </ButtonGroup>}
          </>
        }
      </Container>
      }

      <CompanyConsumer>
        {({
            balancePaymentsLoading,
            balancePaymentsFailure,
            balancePaymentsFailure403,
            balancePayments,
            BalancePaymentHeaderColumns,
            balancePaymentsRefreshLoading,
            isCompanyUnderage,
            companyFailureUnderage,
            companyFailureUnderageMessage,
            balancePaymentsPage,
            balancePaymentsPagesCount,
            balancePaymentsTotalCount,
            handleChangeBalancePaymentsPage,
          }) => (
          <Box p={2} className={'back-white'}>

            {!!balancePaymentsFailure403 ? <UnAuthorize/> :
              (!!isCompanyUnderage && !!companyFailureUnderage ?
                <Alert severity="error">
                  {companyFailureUnderageMessage}
                  <FormattedMessage id='Underage.ErrorAlert' values={{
                    a: chunks => <NavLink
                      to={formatRoute(NamedRoutes.workspace.company.delegates, { id: selectedCompany.id })}>{chunks}</NavLink>
                  }}/></Alert>
                  : (!!selectedCompany?.is_inherited_reality_owner ?
                    <Alert severity="error" className={classes.linkCompanyErrorMessage}>
                      <FormattedMessage 
                        id='InheritedReality.taxService.ErrorAlert' 
                        values={{
                          a: chunks => <NavLink
                            to={formatRoute(NamedRoutes.workspace.company.delegates, { id: selectedCompany.id })}>{chunks}</NavLink>
                        }}
                      />
                    </Alert>
                : ((!!balancePaymentsFailure || !!paymentsFiltersFailure) &&
                  <Alert severity="error"><FormattedMessage id='BasicInfo.FormErrorAlert'/></Alert>
                )))
            }

            {!balancePaymentsFailure403 && !companyFailureUnderage && !selectedCompany?.is_inherited_reality_owner && !(!!isCompanyUnderage && !!balancePaymentsLoading) &&
            <PaymentsBalanceFilter paymentsFiltersData={paymentsFiltersData}
                                   availableBalance={availableBalance}
                                   handleSubmitBalancePaymentsFilter={handleSubmitBalancePaymentsFilter}/>}
            {!!balancePaymentsLoading && <SearchLoader loading={true}/>}
            {(!!balancePayments && !!balancePayments.length) ?
              <PaymentsBalanceTable rows={balancePayments} columns={BalancePaymentHeaderColumns}
                                    availableBalance={availableBalance} Mobile={Mobile}
                                    pagesCount={balancePaymentsPagesCount}
                                    handleChangePage={handleChangeBalancePaymentsPage}
                                    page={balancePaymentsPage} loading={balancePaymentsRefreshLoading}
                                    totalCount={balancePaymentsTotalCount || 0}/>
              :
              <>
                {!!balancePaymentsRefreshLoading &&
                <div className={classes.refreshWrapper}><FormLoader loading={true}/></div>}
                {!balancePaymentsLoading && !balancePaymentsRefreshLoading && !balancePaymentsFailure403 && !companyFailureUnderage &&
                <EmptyResult isPayments={true}/>}
              </>
            }
          </Box>
        )}
      </CompanyConsumer>

    </>
  )
}

export default CompanyPaymentsBalance
